import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
  import LoadingSpinner from '../common/LoadingSpinner.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IframePopup',
  setup(__props) {

  const loading = ref(true)

  const iframeLoaded = () => {
    ;(window as any).iFrameResize({ log: false }, '#iframePopupModal')
    loading.value = false
  }

return { __sfc: true,loading, iframeLoaded, ref, LoadingSpinner }
}

})